const files = import.meta.globEager("./*.js");

const modules = {};
for (const key in files) {
  if (key === "./index.js") continue;
  modules[key.replace(/(\.\/|\.js)/g, "")] = files[key].default;
}

export default modules;
